export const evaluationStatus = {
  locked: "Completed (Signed & Locked)",
  unlocked: "In Progress"
};
